import React from 'react';
import { Box } from '@mui/material';

import { Field, SectionTitle } from '@components';
import {
  consumerDepositsAveragePaymentsOptions,
  consumerDepositsAgeOptions,
  consumerDepositsTurnoverOptions,
  consumerDepositsNumberOfVehiclesOptions,
  consumerDepositsUnpaidAmountOptions,
  consumerDepositsUnpaidAgingDaysOptions,
  consumerStandingOrderAveragePaymentsOptions,
  consumerStandingOrderAgeOptions,
  consumerStandingOrderTurnoverOptions,
  consumerStandingOrderNumberOfVehiclesOptions,
  consumerStandingOrderUnpaidAmountOptions,
  consumerStandingOrderUnpaidAgingDaysOptions,
  consumerStandingOrderSuccessRateFixedAssetsOptions,
} from '@constants';

import styles from './creditScoreForm.style';

export const Consumer = ({ loading, methods }) => {
  const _getTotal = (type) => {
    return methods.getValues(`b2c.${type}.total`) || '-';
  };

  const _isRequired = (field) => {
    const state = methods.getFieldState(field);
    return state.invalid || state.isDirty;
  };

  return (
    <Box sx={{ ...styles.section }}>
      <SectionTitle styles={{ ...styles.title }}>B2C</SectionTitle>

      <Box sx={{ ...styles.subsection }}>
        <div>
          <SectionTitle styles={{ ...styles.subtitle }}>
            {`Deposit (Score: ${_getTotal('deposit')})`}
          </SectionTitle>

          <Box sx={{ ...styles.row }}>
            <Field
              label="Μ.Ο. ΠΛΗΡΩΜΩΝ"
              name="b2c.deposit.averagePaymentDays"
              control={methods.control}
              type="dropdown"
              options={consumerDepositsAveragePaymentsOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.deposit.averagePaymentDays')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΗΛΙΚΙΑ"
              name="b2c.deposit.age"
              control={methods.control}
              type="dropdown"
              options={consumerDepositsAgeOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.deposit.age')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΤΖΙΡΟΣ"
              name="b2c.deposit.turnover"
              control={methods.control}
              type="dropdown"
              options={consumerDepositsTurnoverOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.deposit.turnover')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΟΧΗΜΑΤΑ"
              name="b2c.deposit.vehicles"
              control={methods.control}
              type="dropdown"
              options={consumerDepositsNumberOfVehiclesOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.deposit.vehicles')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ"
              name="b2c.deposit.unpaidAmount"
              control={methods.control}
              type="dropdown"
              options={consumerDepositsUnpaidAmountOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.deposit.unpaidAmount')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ AGING"
              name="b2c.deposit.unpaidAgingDays"
              control={methods.control}
              type="dropdown"
              options={consumerDepositsUnpaidAgingDaysOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.deposit.unpaidAgingDays')}
            />
          </Box>
        </div>

        <div>
          <SectionTitle styles={{ ...styles.subtitle }}>
            {`Standing Order (Score: ${_getTotal('standingOrder')})`}
          </SectionTitle>

          <Box sx={{ ...styles.row }}>
            <Field
              label="Μ.Ο. ΠΛΗΡΩΜΩΝ"
              name="b2c.standingOrder.averagePaymentDays"
              control={methods.control}
              type="dropdown"
              options={consumerStandingOrderAveragePaymentsOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.standingOrder.averagePaymentDays')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΗΛΙΚΙΑ"
              name="b2c.standingOrder.age"
              control={methods.control}
              type="dropdown"
              options={consumerStandingOrderAgeOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.standingOrder.age')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΤΖΙΡΟΣ"
              name="b2c.standingOrder.turnover"
              control={methods.control}
              type="dropdown"
              options={consumerStandingOrderTurnoverOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.standingOrder.turnover')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΟΧΗΜΑΤΑ"
              name="b2c.standingOrder.vehicles"
              control={methods.control}
              type="dropdown"
              options={consumerStandingOrderNumberOfVehiclesOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.standingOrder.vehicles')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ"
              name="b2c.standingOrder.unpaidAmount"
              control={methods.control}
              type="dropdown"
              options={consumerStandingOrderUnpaidAmountOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.standingOrder.unpaidAmount')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="AΝΕΞΟΦΛΗΤO ΠΟΣΟ AGING"
              name="b2c.standingOrder.unpaidAgingDays"
              control={methods.control}
              type="dropdown"
              options={consumerStandingOrderUnpaidAgingDaysOptions}
              disabled={loading}
              isRequired={_isRequired('b2c.standingOrder.unpaidAgingDays')}
            />
          </Box>
          <Box sx={{ ...styles.row }}>
            <Field
              label="ΠΟΣΟΣΤΟ ΕΠΙΤΥΧΙΑΣ ΠΑΓΙΩΝ"
              name="b2c.standingOrder.successRateStandingOrders"
              control={methods.control}
              type="dropdown"
              options={consumerStandingOrderSuccessRateFixedAssetsOptions}
              disabled={loading}
              isRequired={_isRequired(
                'b2c.standingOrder.successRateStandingOrders'
              )}
            />
          </Box>
        </div>
      </Box>
    </Box>
  );
};

export default Consumer;
